var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic-off",
    clipPath: "url(#clip0_826_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33301 1.3335L30.6663 30.6668",
    stroke: "#1D2739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 11.9998V15.9998C12.0007 16.7904 12.2357 17.5631 12.6752 18.2202C13.1148 18.8774 13.7393 19.3895 14.4697 19.692C15.2002 19.9945 16.0039 20.0737 16.7794 19.9196C17.5549 19.7656 18.2673 19.3852 18.8267 18.8265M20 12.4531V5.33313C20.001 4.34117 19.6334 3.38422 18.9685 2.64806C18.3036 1.9119 17.3889 1.44905 16.402 1.34936C15.4151 1.24967 14.4263 1.52025 13.6276 2.10858C12.829 2.69691 12.2774 3.56101 12.08 4.53313",
    stroke: "#1D2739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.6663 22.6002C21.3646 23.9287 19.6958 24.8381 17.8737 25.2116C16.0517 25.5852 14.1596 25.4058 12.4403 24.6965C10.7209 23.9873 9.25261 22.7805 8.22383 21.231C7.19504 19.6816 6.65266 17.86 6.66627 16.0002V13.3335M25.3329 13.3335V16.0002C25.3325 16.5501 25.2834 17.0989 25.1863 17.6402",
    stroke: "#1D2739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 25.3335V30.6668",
    stroke: "#1D2739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.667 30.6665H21.3337",
    stroke: "#1D2739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_826_2153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic-off.d3d2f4042615bcbb131b334edb988795.svg";
export { ForwardRef as ReactComponent };